<nb-card>

  <nb-card-header>
    Asignar trabajador
  </nb-card-header>

  <nb-card-body>

    <nb-select fullWidth placeholder="Seleccionar trabajador" [(selected)]="workerId">

      <nb-option *ngFor="let w of workers" [value]="w.id">
        {{ w.name }}
      </nb-option>

    </nb-select>

  </nb-card-body>

  <nb-card-footer>
    <div class="d-flex">
      <button nbButton status="primary" style="margin-right: 20px;" (click)="asignar()">
        Asignar
      </button>

      <button nbButton status="basic" (click)="cancelar()">
        Cancelar
      </button>
    </div>
  </nb-card-footer>

</nb-card>